import { render, staticRenderFns } from "./Free_shipping.vue?vue&type=template&id=41310119&scoped=true&"
import script from "./Free_shipping.vue?vue&type=script&lang=js&"
export * from "./Free_shipping.vue?vue&type=script&lang=js&"
import style0 from "./Free_shipping.vue?vue&type=style&index=0&id=41310119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41310119",
  null
  
)

export default component.exports